module.exports = {"410102001":"林山寨街道","410102002":"建设路街道","410102003":"棉纺路街道","410102004":"秦岭路街道","410102005":"桐柏路街道","410102006":"三官庙街道","410102007":"绿东村街道","410102008":"汝河路街道","410102009":"航海西路街道","410102010":"中原西路街道","410102011":"西流湖街道","410102012":"须水街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410102.json
// module id = 1513
// module chunks = 0